import { render, staticRenderFns } from "./SnackGeneral.vue?vue&type=template&id=4e534c06&scoped=true&"
import script from "./SnackGeneral.vue?vue&type=script&lang=js&"
export * from "./SnackGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e534c06",
  null
  
)

export default component.exports